@if (obser$ | async; as obser) {
  <div class="d-flex align-items-center flex-column">
    <form-wrapper>
      <div class="d-flex align-items-center flex-column">
        <investor-profile></investor-profile>
        <contract-box></contract-box>
        <div class="description">
          Dernière ligne droite ! Finalisez l'investissement qui vous
          correspond.
        </div>
      </div>
    </form-wrapper>
    <div class="btn-group">
      @if (step > 1) {
        <pr-button
          size="lg"
          type="button"
          label="Question précédente"
          icon="arrow_left"
          (onClick)="prev()"
        ></pr-button>
      }
      <pr-button
        style="margin-left: auto"
        size="lg"
        type="submit"
        display="neutral"
        label="C'est parti !"
        (onClick)="next()"
      ></pr-button>
    </div>
  </div>
} @else {
  @if (loading) {
    <pr-loader></pr-loader>
  }
}
